import { render, staticRenderFns } from "./TestCard.vue?vue&type=template&id=1261b3ba&scoped=true&"
import script from "./TestCard.vue?vue&type=script&lang=js&"
export * from "./TestCard.vue?vue&type=script&lang=js&"
import style0 from "./TestCard.vue?vue&type=style&index=0&id=1261b3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261b3ba",
  null
  
)

export default component.exports